import cn from "classnames"
import React from "react"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Factoids: React.FC<{ className?: string }> = ({ className }) => {
  const { facts } = useApiContext("/sustainable/page")

  return (
    <div className={cn(className, styles.Wrapper)}>
      {facts.map(({ heading, number, description }, i) => (
        <div key={i} className={styles.Factoid}>
          <Heading className={styles.Name} like="h5">
            <Raw html={heading} />
          </Heading>

          <div>
            <Heading className={styles.Value} like="h3">
              <Raw html={number} />
            </Heading>

            <Raw html={description} />
          </div>
        </div>
      ))}
    </div>
  )
}
